<template>
  <div>
    <template>
      <button
        class="btn wf-product-download-button-close"
        type="button"
        @click="closeModal()"
      >
        <span
          class="png-icon png-icon-icons-glyph--k-close"
          aria-label="Close view mode 'swatch'"
        />
      </button>
    </template>
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {
    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },
    closeModal() {
      this.hideModal("show-download-view");
    }
  }
};
</script>
